import { StyleSheet, StyleProp, TextStyle } from 'react-native';
import { theme } from '@socrait/react';

// Common header text style that's reused across all steps
const headerTextBase: StyleProp<TextStyle> = {
  textAlign: 'center',
  fontSize: theme.fontSizes.xlarge,
  lineHeight: theme.fontSizes.xlarge * 1.4,
};

export const setupStepStyles = StyleSheet.create({
  // Container used by all steps
  container: {
    flex: 1,
    alignItems: 'stretch',
    gap: theme.spacing.xlarge * 2,
    padding: theme.spacing.xlarge,
  },

  // Header container (used by TeacherSetupStep and ClassSetupStep)
  headerContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing.xsmall,
  },

  contentContainer: {
    flex: 1,
    gap: theme.spacing.xlarge,
  },

  // Main header text
  headerText: {
    ...headerTextBase,
  },

  // Purple variant of header text
  headerTextPurple: {
    ...headerTextBase,
    color: theme.colors.primaryPurple,
  },

  // Small text size
  smallText: {
    fontSize: theme.fontSizes.small,
  },

  // Text container for informational screens
  textContainer: {
    paddingHorizontal: theme.spacing.large,
  },

  // Body text for informational screens
  text: {
    textAlign: 'center',
    fontSize: theme.fontSizes.xmedium,
    lineHeight: theme.lineHeights.medium,
  },
});
